import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { SequenceTable } from '../../atomicComponents';

const HeijunkaSequencePreviewTable = ({
  selectedOptionalColNames,
  sequenceData,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (sequenceData.data.length > 0) {
      setData(
        sequenceData.data.map(record => ({ ...record, ...record.attributes })),
      );
    }
  }, [sequenceData]);

  return (
    <SequenceTable
      showRowNumbers
      sourceRows={data}
      maxEmptyRowPadding={13}
      selectedOptionalColNames={selectedOptionalColNames}
    />
  );
};

HeijunkaSequencePreviewTable.propTypes = {
  sequenceData: PropTypes.shape({
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
  }),
  selectedOptionalColNames: PropTypes.arrayOf(PropTypes.string),
};

export default HeijunkaSequencePreviewTable;
